import BlogActionMenu from "./BlogActionMenu";
import {Link} from 'react-router-dom';
import {isoToLocaleDateTimeFormat} from "../../../helpers/dateTimeHelper";
import CustomIcon from "../../../components/CustomIcon";
import {BLOG_STATE_ACTIVE} from "../constants";
import {generateLinkForBlogPage} from "../../../helpers/seoHelper";
import {generateFullUrl} from "../../../helpers/helperFunctions";

export default function ManageBlogGridItem({blog}) {

  const tagsLen = blog.tags?.length ?? 0;

  return (
    <div className="bg-secondary-100 border rounded-lg overflow-hidden">
      <Link to={{pathname: `/blogs/${blog.id}`}}>
        <img className="w-full aspect-[16/9] object-cover bg-gray-100" alt="Image" title={blog?.seo_details.title}
             src={blog?.seo_details.image}/>
      </Link>

      <div className="p-3 border-t">
        <div className="text-sm leading-relaxed font-bold text-2-clamp mb-1 h-11">{blog?.title}</div>
        <div className="text-xs mb-3">Created: {isoToLocaleDateTimeFormat(blog.created_at)} </div>
        <div className="flex justify-between items-center">
          <div className="text-xs">{tagsLen} tag{tagsLen > 1 ? 's' : ''}</div>
          <div className="space-x-2">
            <_PreviewPublished blog={blog}/>
            <BlogActionMenu blog={blog}/>
          </div>

        </div>
      </div>

    </div>
  );
}

const _PreviewPublished = ({blog}) => {

  const handlePreview = () => {
    window.open(generateFullUrl(generateLinkForBlogPage(blog)), '_blank');
  };

  const isPublished = blog.state === BLOG_STATE_ACTIVE;

  return (
    <>
      {isPublished && <CustomIcon size="xl" className="cursor-pointer" onClick={handlePreview}
                                  icon="preview"/>}
    </>
  );
};




